import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import {
  LoginValidationSchema,
  LoginValidationType,
} from "../../schemas-and-types/login/login.schema";

import { PublicClientApplication } from "@azure/msal-browser";
import { useState } from "react";
import Loader from "../../components/global/Loader/Loader";
import { msalInstance } from "../../configurations/auth/msal.auth.configuration";
import useTranslation from "../../hooks/useTranslation";
import styles from "./Login.module.scss";

export default function Login() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  //* react-hook-form
  const { handleSubmit } = useForm<LoginValidationType>({
    resolver: yupResolver(LoginValidationSchema),
  });

  async function onLogin() {
    await msalInstance.loginRedirect();
  }

  function loginWithRedirectAndLoading(msalInstance: PublicClientApplication) {
    return new Promise(async (resolve, reject) => {
      setIsLoading(true);
      try {
        await msalInstance.loginRedirect();
        setIsLoading(false);
        resolve(null);
      } catch (error) {
        setIsLoading(false);
        reject(error);
      }
    });
  }

  return (
    <article className={styles.login}>
      {/* {console.log('login', isLoading) as any} */}
      {isLoading && <Loader />}
      <form
        onSubmit={handleSubmit(onLogin)}
        className={styles.login__loginWindow}
      >
        <header className={styles.login__loginWindow__header}>
          {/* <h1>{t('login.connection')}</h1> */}
        </header>
        <main className={styles.login__loginWindow__main}>
          <h1>{t('login.p1')}</h1>
          {/* <h1>{t('login.p2')}</h1> */}
          <h1>{t('login.p3')}</h1>
        </main>

        <footer className={styles.login__loginWindow__footer}>
          <button
            type="submit"
            onClick={async () => {
              await loginWithRedirectAndLoading(msalInstance);
            }}
          >
            {t('login.submit')}
          </button>
        </footer>
      </form>
    </article>
  );
}